const UploadFixedIcon = () => (
  <svg viewBox='0 0 24 24' className='h-[22px] w-[22px]' aria-hidden>
    <path
      d='M6 4h12v16H6z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.6'
      rx='2'
    />
    <path d='M9 9h6M9 13h6M9 17h3' stroke='currentColor' strokeWidth='1.6' />
  </svg>
);
export default UploadFixedIcon;
